import httpUtil from "@/utils/httpUtil";

export const selectFormulaList = params => httpUtil.get("/storeFormula", params);


export const addFormula = params => httpUtil.post("/storeFormula", params);


export const selectAllFormula = params => httpUtil.get("/storeFormula/noPage", params);


export const delFormula = params => httpUtil.post("/storeFormula/delete", params);
